import { useState, useEffect } from 'react';
import './App.css';
import { Text } from 'react-native';
import { createClient } from '@supabase/supabase-js';
import { Grid } from '@mui/material';
import toast, { Toaster } from 'react-hot-toast';
import DATA from './data/symbols.json';
import Arrangement from './Arrangement.tsx';
import pinyin from 'pinyin';

// function getSurrogatePair(astralCodePoint) {
//     debugger;
//     let highSurrogate =
//         Math.floor((astralCodePoint - 0x10000) / 0x400) + 0xd800;
//     let lowSurrogate = ((astralCodePoint - 0x10000) % 0x400) + 0xdc00;
//     return [highSurrogate, lowSurrogate];
// }

function App() {
    const client = createClient(
        'https://kqeohpicrysfncnyycdr.supabase.co',
        process.env.REACT_APP_SUPABASE_KEY
    );

    const userId = crypto.randomUUID();
    const [correct, setCorrect] = useState(0);
    const [total, setTotal] = useState(0);
    const getRandomSymbol = () => {
        let randomSymbol =
            DATA.symbols[Math.floor(Math.random() * DATA.symbols.length)];
        while (randomSymbol.length === 2) {
            randomSymbol =
                DATA.symbols[Math.floor(Math.random() * DATA.symbols.length)];
        }
        return randomSymbol;
    };

    const [isMobile, setIsMobile] = useState(window.innerWidth < 720);
    const handleResize = () => {
        if (window.innerWidth < 720) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    };
    useEffect(() => {
        window.addEventListener('resize', handleResize);
    });

    const [lastSymbol, setLastSymbol] = useState('');
    const [symbol, setSymbol] = useState(getRandomSymbol());
    const [orientationsThisTurn, setOrientationsThisTurn] = useState(
        ['0deg', '90deg', '180deg', '270deg'].sort(() => Math.random() - 0.5)
    );
    const checkAnswer = async (symbol, orientation) => {
        setTotal(total + 1);
        toast.dismiss();
        const { error } = await client
            .from('main')
            .insert({ symbol, orientation, user_id: userId });

        console.log(error);
        orientation === '0deg'
            ? toast.success('Correct')
            : toast.error('Error');
        if (orientation === '0deg') setCorrect(correct + 1);
        setLastSymbol(symbol);
        setSymbol(getRandomSymbol());
        setOrientationsThisTurn(
            ['0deg', '90deg', '180deg', '270deg'].sort(
                () => Math.random() - 0.5
            )
        );
    };
    return (
        <div className="App">
            <div>
                <Toaster />
            </div>
            <div>
                <h1>Guess the orientation!</h1>
                <Grid container spacing={2}>
                    <Grid item xs={3} />
                    <Grid item xs={3}>
                        <h3>
                            Total: {correct} / {total} (
                            {total === 0
                                ? 0
                                : Math.round((1000 * correct) / total) / 10}
                            %)
                        </h3>
                    </Grid>
                    <Grid item xs={3}>
                        <h3>
                            {lastSymbol !== '' ? (
                                <a
                                    href={`https://www.mdbg.net/chinese/dictionary?page=worddict&wdrst=0&wdqb=${lastSymbol}`}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Last symbol:{' '}
                                    <Text style={{ fontSize: 20 }}>
                                        {lastSymbol}
                                    </Text>{' '}
                                    {lastSymbol !== ''
                                        ? '(' +
                                          pinyin(lastSymbol, {
                                              heteronym: true,
                                          })
                                              .flatMap((k) => k)
                                              .join('/') +
                                          ')'
                                        : ''}
                                </a>
                            ) : (
                                ''
                            )}
                        </h3>
                    </Grid>
                </Grid>
            </div>
            <div
                style={{
                    marginTop: '3em',
                    alignContent: 'center',
                    alignSelf: 'center',
                }}
            >
                <Arrangement
                    orientations={orientationsThisTurn}
                    symbol={symbol}
                    checkAnswer={checkAnswer}
                    isMobile={isMobile}
                />
            </div>
        </div>
    );
}

export default App;
